import React, { useState, useEffect, useContext } from "react";
//import Select from "../common/customselect";
import Select from "./select";
import Input from "./input";
import dlv from "dlv";
import {
  getProductType,
  getProduct,
  getaim
} from "./../../services/wms/grabconcept";
import { GetCompany, getTreetype, getqueueonline ,getdatafsc} from "../../services/wms";
import BranchContext from "./../context/branch";
import Joi from "joi-browser";
import ModelSelect from "./../common/modalselect";

const Productcard = (props) => {
  const {
    handleProOption2,
    handleProOption1,
    id,
    DO,
    labelProOption1,
    proname,
    typename,
    head,
    handleChangeavgwood,
    handleChangeProductType,
    handleChangeProduct,
    handleChangeTreetype,
    handleChangetypefsc,
    labelProOption2,
    handleChangeAim,
    onChange,
    aimname,
    allEditData,
    paramsMatchId,
    registerError,
    handelComIdChange,
    handleChangelot,
    chkqueuetype,onLoad
  } = props;

  const { currentBranch } = useContext(BranchContext);

  const ojb = allEditData[0];

  let editProductTypeId = dlv(ojb, "type_id", 0);
  let editProductID = dlv(ojb, "ProductID", 0);
  let editProOption1 = dlv(ojb, "option1", "");
  let editProOption2 = dlv(ojb, "option2", "");
  let editAimId = dlv(ojb, "receive_aim", "00");
  let editsourceid = dlv(ojb, "souceid", "0");
  let edittreetypeid = dlv(ojb, "WoodType_ID", "05");
  let editDo = dlv(ojb, "DO", "");
  let editlot = dlv(ojb, "productlot", "");
  const [vForm, setvForm] = useState(false);
  const [chkqueue, setchkqueue] = useState([]);
  const [productType, setproductType] = useState([]);
  const [comsource, setcomsource] = useState([]);
  const [product, setproduct] = useState([]);
  const [treetype, settreetype] = useState([]);
  const [treetypeId, settreetypeId] = useState(edittreetypeid);
  const [productTypeId, setProductTtpeId] = useState(editProductTypeId);
  const [productid, setproductid] = useState(editProductID);
  const [option1, setoption1] = useState(editProOption1);
  const [option2, setoption2] = useState(editProOption2);
  const [aimNo, setaimNo] = useState([]);
  const [aimId, setaimId] = useState(editAimId);
  const [comsourceid, setcomsourceid] = useState(editsourceid);
  const [doId, setdoId] = useState(editDo);
  const [avgwood, setavgwood] = useState("0");
  const [lotid, setlot] = useState(editlot);
  const [openModalSearch, setOpenModalSearch] = useState(false);
  const [openModalSearchProtype, setOpenModalSearchProtype] = useState(false);
  const [stateData, setstateData] = useState({
    data: {
      DO: "",
    },
    errors: { enable: false, message: "" },
  });
  const [typefsc, settypefsc] = useState([]);
  const [fscId, setfscId] = useState(0);
  useEffect(() => {
    if (!currentBranch) return;
    if (!productid) return;
   if (!onLoad) return;
    const loadData = async () => {
      if (currentBranch && currentBranch._id == "501" && productTypeId == "5") {
        const { data: result } = await GetCompany(
          currentBranch && currentBranch._id,
          productid
        );
        if (result) {

          setcomsource(result);
        }
      } else if (
        (currentBranch && currentBranch._id === "503") ||
        currentBranch._id === "502"
      ) {
        const { data: result } = await GetCompany(
          currentBranch && currentBranch._id,
          productid
        );
        if (result) {
          setcomsource(result);
          if (result && result.length > 0) {
            setcomsourceid(result[0]._id)
            handelComIdChange(result[0]._id)
          }
         
        }
      } else {
        setcomsource([]);
      }
    };
    loadData();
  }, [currentBranch, productid, productTypeId,onLoad]);

  useEffect(() => {
    if (!currentBranch) return;
    if (currentBranch._id === "") return;
    settypefsc([
      { _id: 1, name: "Non-FSC" },
      { _id: 2, name: "Controlled Material" },
      { _id: 3, name: "FSC 100%" },
    ]);
    // const loadData = async () => {
    //   const { data: result } = await getdatafsc();
    //   if (result.status === "success") {
    //     setfsc(result.data.list);
    //   }
    // };
    // loadData();
  }, [currentBranch]);
  // useEffect(() => {
  //   if (!currentBranch) return;
  //   if (currentBranch._id === "") return;
  //   if (!onLoad) return;
  //   if (currentBranch && currentBranch._id !== "501") return;
  //   const loadData = async () => {
  //     const { data: result } = await getdatafsc();
  //     if (result.status === "success") { 
  //       settypefsc(result.data.list);
  //     }
  //   };
  //   loadData();
  // }, [currentBranch,onLoad]);

  useEffect(() => {
    if (!onLoad) return;
    if (!currentBranch) return;
    if (currentBranch && currentBranch._id !== "501") return;
    const loadData = async () => {
      const { data: result } = await getTreetype(
        currentBranch && currentBranch._id
      );
      if (result.status === "success") {
    
        settreetype(result.data.list);
      }
    };
    loadData();
  }, [currentBranch,onLoad]);

  useEffect(() => {
    if (!currentBranch) return;
    if (!onLoad) return;
    if (currentBranch && currentBranch._id !== "501") return;
    const loadData = async () => {
      const { data: result } = await getqueueonline(
        currentBranch._id,
        productid
      );

      if (result.length > 0) {
        setchkqueue(result[0].checkqueue);

      } else {
        setchkqueue(false);

      }
    };
    loadData();
  }, [currentBranch, productid,onLoad]);

  useEffect(() => {
    if (!currentBranch) return;
    if (!currentBranch._id) return;
    if (!onLoad) return;
    const loadData = async () => {
      const { data: result } = await getProductType(
        currentBranch && currentBranch._id
      );
      if (result && result.length > 0) {
        setproductType(result);
      } else {
        setproductType([]);
      }
    };
    loadData();
  }, [currentBranch]);

  useEffect(() => {
    if (!currentBranch) return;
    if (!currentBranch._id) return;
    if (!onLoad) return;
    const loadData = async () => {
      const { data: result } = await getProduct(
        productTypeId,
        currentBranch && currentBranch._id
      );
      if (result) {
        setproduct(result);
      }
    };
    loadData();
  }, [productTypeId, currentBranch]);
  
  useEffect(() => {
    if (!currentBranch) return;
    if (!onLoad) return;
    const loadData = async () => {
      const { data: result } = await getaim(currentBranch && currentBranch._id);
      if (result) {
        setaimNo(result);
      }
    };
    loadData();
  }, [currentBranch]);



  useEffect(() => {
    if (vForm) return;
    if (!currentBranch) return;

    const onload = () => {
      if (registerError) {
        const data = { ...stateData.data };
        setstateData({
          data,
          errors: { enable: false, message: registerError.DO },
        });
        setvForm(true);
      } else {
        // setvForm(true);
      }
    };
    onload();
  });

  let schema1 = {
    DO: Joi.string().min(0).max(99999999).required().label("DO"),
  };

  const validateProperty = ({ name, value }) => {
    try {
      const obj = { [name]: value };
      const schema = { [name]: schema1[name] };
      const options = { abortEarly: true };
      const { error } = Joi.validate(obj, schema, options);
      return error ? error.details[0].message : null;
    } catch (err) {

      return err.message;
    }
  };

  const handelOption1 = ({ currentTarget: input }) => {
    setoption1(input.value);
    handleProOption1(input.value);
  };
  const handelavgwood = ({ currentTarget: input }) => {
    setavgwood(input.value);
    handleChangeavgwood(input.value);
  };
  const handellot = ({ currentTarget: input }) => {
    setlot(input.value);
    handleChangelot(input.value);
  };
  const handelOption2 = ({ currentTarget: input }) => {
    setoption2(input.value);
    handleProOption2(input.value);
  };
  function handleChangProductID(event) {
    setproductid(event.currentTarget.value);
    handleChangeProduct(event.currentTarget.value);
  }

  const handleChangeCompanyID = (event) => {
    setcomsourceid(event.currentTarget.value);
    handelComIdChange(event.currentTarget.value);
  };
  const handleTreetypechange = (event) => {
    settreetypeId(event.currentTarget.value);
    handleChangeTreetype(event.currentTarget.value);
  };
  const handlefscchange = (event) => {
    setfscId(event.currentTarget.value);
    handleChangetypefsc(event.currentTarget.value);
  };
  const handleTextchange = ({ currentTarget: input }) => {
    const data = { ...stateData.data };
    const errors = { ...stateData.errors };
    if (input.name in data) {
      const errorMessage = validateProperty(input);
      if (errorMessage) errors[input.name] = errorMessage;
      else delete errors[input.name];
      data[input.name] = input.value;

      setstateData({ data, errors: { enable: false, message: errorMessage } });
      if (errorMessage && !input.value === "") return;
      setdoId(input.value);
      onChange(input.value);
    }
  };
  const handleChangeAimNo = (event) => {
    setaimId(event.currentTarget.value);
    handleChangeAim(event.currentTarget.value);
  };
  const handleChangeProductTypeID = (event) => {
    setProductTtpeId(event.currentTarget.value);
    handleChangeProductType(event.currentTarget.value);
  };

  const handleSearchClick = () => {
    setOpenModalSearch(true);
  };

  const handleSearchTypeClick = () => {
    setOpenModalSearchProtype(true);
  };
  const handleConfirmSubmit = ({ currentTarget: input }) => {
    setOpenModalSearch(false);
    setproductid(input.value);
    handleChangeProduct(input.value);
  };

  const handleConfirmTypeSubmit = ({ currentTarget: input }) => {
    setOpenModalSearchProtype(false);
    setProductTtpeId(input.value);
    handleChangeProductType(input.value);
  };

  const handleCancleSubmit = () => {
    setOpenModalSearch(false);
  };
  const handleCancleTypeSubmit = () => {
    setOpenModalSearchProtype(false);
  };

  if (
    !currentBranch ||
    !id ||
    (!paramsMatchId == "new" && !editProductTypeId)
  ) {
    return <div></div>;
  }
  return (
    <div className="container-fluid">
      <ModelSelect
        isOpen={openModalSearch}
        label="ค้นหาสินค้า"
        onCancel={handleCancleSubmit}
        onSelected={handleConfirmSubmit}
        list={product}
        textProperty="ProductName"
        valueProperty="Product_ID"
      />
      <ModelSelect
        isOpen={openModalSearchProtype}
        label="ค้นหาประเภทสินค้า"
        onCancel={handleCancleTypeSubmit}
        onSelected={handleConfirmTypeSubmit}
        list={productType}
        textProperty="type_name"
        valueProperty="Type_ID"
      />
      <div className="row">
        <div className="col-lg-12">
          <div className="card mb-4">
            <span className="info-box-icon bg-primary text-light">
              <i className="fa fa-shopping-basket ms-2 my-2"></i>
              <span> {head} </span>
            </span>
            <div className="card-body">
              <div className="row">
                <div className="col-sm-6">
                  <Select
                    data={productType}
                    label={typename}
                    value={productTypeId}
                    textProperty="type_name"
                    valueProperty="Type_ID"
                    onChange={handleChangeProductTypeID}
                    onClick={handleSearchTypeClick}
                    search="ค้นหา"
                  />
                </div>

                <div className="col-sm-6">
                  <Select
                    data={product}
                    label={proname}
                    value={productid}
                    textProperty="ProductName"
                    valueProperty="Product_ID"
                    onChange={handleChangProductID}
                    onClick={handleSearchClick}
                    search="ค้นหา"
                  />
                </div>
                {comsource && comsource.length > 0 && (
                  <div className="col-sm-6">
                    <div className="form-group">
                      <Select
                        data={comsource}
                        label={"บริษัทที่ลงสินค้า"}
                        value={comsourceid}
                        textProperty="name"
                        valueProperty="_id"
                        onChange={handleChangeCompanyID}
                      />
                    </div>
                  </div>
                )}
                {currentBranch &&
                  (currentBranch._id == "503" ||
                    currentBranch._id == "502") && (
                    <div className="col-sm-6 mt-4">
                      <Input
                        name="Lot"
                        value={lotid}
                        label={"Lot สินค้า"}
                        onChange={handellot}
                      />
                    </div>
                  )}
              </div>

              <div className="col-xs-12">
                <div className="row">
                  <div className="col-sm-6 my-1 mt-4">
                    <Select
                      data={aimNo}
                      label={aimname}
                      value={aimId}
                      textProperty="aim_name"
                      valueProperty="aim_no"
                      onChange={handleChangeAimNo}
                    />
                  </div>

                  {currentBranch && currentBranch._id == "505" && (
                    <div className="col-sm-6 my-1 mt-4">
                      <Input
                        name="PO"
                        value={option2}
                        label={labelProOption2}
                        onChange={handelOption2}
                      />
                    </div>
                  )}

                  <div className="col-sm-6 my-1">
                    <Input
                      name="DO"
                      value={doId}
                      label={DO}
                      onChange={handleTextchange}
                      error={stateData.errors.message}
                    />
                  </div>             
                  {currentBranch &&
                    currentBranch._id == "501" &&
                    (productTypeId == "10" || productTypeId == "2") && (
                      <div className="col-sm-6 my-1 ">
                        <Select
                          name="treetype"
                          data={treetype}
                          value={treetypeId}
                          label={"พันธุ์ไม้"}
                          textProperty="name"
                          valueProperty="_id"
                          onChange={handleTreetypechange}
                        />         
                      </div>
                    )}

                    {currentBranch &&
                    currentBranch._id == "501" &&
                    (productTypeId == "10") && (
                            <div className="col-sm-6 my-1 ">
                        <Select
                          name="treetype"
                          data={typefsc}
                          value={fscId}
                          label={"ประเภทไม้ FSC"}
                          textProperty="name"
                          valueProperty="_id"
                          onChange={handlefscchange}
                        />
                      </div>
                     
                    )}

                  {currentBranch &&
                    currentBranch._id == "501" &&
                    (productTypeId == "10" || productTypeId == "2") && (
                      <div className="col-sm-6 my-1 ">
                        <Input
                          name="avgwood"
                          value={avgwood}
                          type="number"
                          label="อายุไม้"
                          onChange={handelavgwood}
                          error={stateData.errors.message}
                        />
                      </div>
                    )}
                  {currentBranch && currentBranch._id == "505" && (
                    <div className="col-sm-6 my-1 ">
                      {" "}
                      <Input
                        name="option1"
                        value={option1}
                        label={labelProOption1}
                        onChange={handelOption1}
                      />{" "}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>          
      </div>
      </div>
    </div>
  );
};

export default Productcard;
